import React, { useRef, useEffect } from "react";
import "./CustomerTicketsModal.css"; // Import custom styles if needed

const CustomerTicketsModal = ({ isOpen, onClose, ticketDetails }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    // Function to handle clicks outside the modal
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener to document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  // Function to handle redirection
  const handleTicketClick = (ticketId) => {
    window.open(
      `https://ameyo.lightning.force.com/lightning/r/Case/${ticketId}/view`,
      "_blank"
    );
  };

  return (
    <div className="ticket-details-modal">
      <div className="modal-content" ref={modalRef}>
        <span
          className="close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 10,
            right: 20,
            cursor: "pointer",
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          &times;
        </span>
        <h1 className="text-lg font-bold pt-1">Ticket Details</h1>
        {ticketDetails.length === 0 ? (
          <p>No ticket details available.</p>
        ) : (
          <div className="overflow-y-auto overflow-x-auto max-h-[70vh] pt-6">
            <ul>
              {ticketDetails.map((ticket) => (
                <li key={ticket.id}>
                  <p>
                    <strong>ID:</strong>{" "}
                    <button
                      onClick={() => handleTicketClick(ticket.id)}
                      className="ticket-id-button"
                    >
                      {ticket.id}
                    </button>
                  </p>
                  <p>
                    <strong>Subject:</strong> {ticket.subject}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerTicketsModal;
